import { Link } from "react-router-dom";
import { Palmtree, Timer, Clock, Receipt, LifeBuoy, type LucideIcon } from "lucide-react";

import { Button } from "../../ui/button.js";
import { CardTitle } from "../../ui/card.js";
import { GlowCard } from "../../ui/glow-card.js";
import type { WidgetProps } from "../widget-registry.js";

// Icons match the ones the sidebar and the KPI tiles already use for the same
// modules, so the same destination reads the same wherever it appears.
const ACTIONS: { label: string; href: string; icon: LucideIcon }[] = [
  { label: "Apply for Leave", href: "/leave",      icon: Palmtree },
  { label: "Log Timesheet",   href: "/timesheet",  icon: Timer },
  { label: "Attendance",      href: "/attendance", icon: Clock },
  { label: "Submit Expense",  href: "/expenses",   icon: Receipt },
  { label: "Raise IT Ticket", href: "/assets",     icon: LifeBuoy },
];

/** Shortcuts into the things an employee does most often. */
export function QuickActionsWidget(_props: WidgetProps) {
  return (
    // glow="ultra" is the lightest touch above off: the edge nearest the cursor
    // lifts just enough to show the card reacts, with no bloom past the border.
    // spotlight="low" matches it: the interior pool defaults to medium, which
    // reads as a bright wash on a sparse card like Quick Actions.
    <GlowCard glow="ultra" spotlight="low" size="md" className="h-full">
      <CardTitle className="mb-2.5 text-[13px]">Quick Actions</CardTitle>
      <div className="flex flex-wrap gap-1.5">
        {ACTIONS.map(({ label, href, icon: Icon }) => (
          // "secondary" rather than the solid brand fill: five solid buttons in a
          // row read as five competing primary actions. These are shortcuts, so
          // they carry the icon for scanning and let the page keep its emphasis.
          <Button key={label} asChild variant="secondary" size="sm">
            <Link to={href} className="no-underline">
              <Icon size={14} className="mr-1.5 shrink-0" />
              {label}
            </Link>
          </Button>
        ))}
      </div>
    </GlowCard>
  );
}
